import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface GameType {
  id: string;
  name: string;
  short_description: string;
  long_description: string;
  genre: string;
  image_url: string;
  background_image_url: string;
  intro_video_url: string;
  difficulty_levels: string[];
  rating: string;
  availability: number;
}

export type GameTypes = Record<string, GameType>;

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

const fetchGameTypes = async (): Promise<GameTypes> => {
  const token = localStorage.getItem('token');
  const response = await axios.get<GameTypes>(`${API_URL}/game/types`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const useGameTypes = () => {
  const { data: gameTypes, isLoading, error } = useQuery<GameTypes, Error>({
    queryKey: ['gameTypes'],
    queryFn: fetchGameTypes,
    staleTime: 1000 * 60 * 60, // Consider data fresh for 1 hour
    gcTime: 1000 * 60 * 60 * 2, // Keep in cache for 2 hours
  });

  return { 
    gameTypes: gameTypes as GameTypes | undefined, 
    isLoading, 
    error: error ? error.message : null 
  };
}; 